<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let item of filter.getValues(); let idx = index; trackBy: trackByFunc">
		<button *ngIf="!isDefaultFilter" type="button" mat-icon-button class="circle-icon-remove" (click)="removeValue(idx)"><mat-icon color="accent" svgIcon="md:remove"></mat-icon></button>
		<mat-form-field appearance="outline" class="copo-no-error-message" subscriptSizing="dynamic">
			<mat-label>{{filter.placeholderReference}}</mat-label>
			<input matInput [ngModel]="filter.getValues()[idx].reference" (ngModelChange)="filter.getValues()[idx].reference = $event"/>
		</mat-form-field>
		<span class="separator">/</span>
		<mat-form-field appearance="outline" class="copo-no-error-message" subscriptSizing="dynamic">
			<mat-label>{{filter.placeholderItem}}</mat-label>
			<input matInput [ngModel]="filter.getValues()[idx].item" (ngModelChange)="filter.getValues()[idx].item = $event"/>
		</mat-form-field>
	</div>
</ng-container>
